<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl10" :span="18">
        <!-- <p class="font-16 blue">{{ title }}</p> -->
        <div class="w100 flex-box">
          <div class="font-16 pl20 pr20 cu-p" :class="active == 'CardMyOfficeWDDB' ? 'active' : 'grey'" @click="active = 'CardMyOfficeWDDB'">我的待办</div>
          <div class="font-16 pl20 pr20 cu-p" :class="active == 'CardMyOfficeWDYB' ? 'active' : 'grey'" @click="active = 'CardMyOfficeWDYB'">我的已办</div>
          <div class="font-16 pl20 pr20 cu-p" :class="active == 'CardMyOfficeWDFQ' ? 'active' : 'grey'" @click="active = 'CardMyOfficeWDFQ'">我的发起</div>
          <!-- <div class="font-16 pl20 pr20 cu-p" :class="active == 'CardMyOfficeSWCX' ? 'active' : 'grey'" @click="active = 'CardMyOfficeSWCX'">事务查询</div> -->
        </div>
      </el-col>
      <el-col class="pr10 tx-r" :span="6">
        <router-link class="font-14 grey" :to="{ name: 'server_my_office'}">
          事务查询 <i class="el-icon-arrow-right"></i>
        </router-link>
      </el-col>
    </el-row>
    <div class="po-r w100 pt20 pl20 pr20 pb20 card-main">
      <component :is="active"></component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CardMyOfficeWDDB from "@/components/CardMyOffice/CardMyOfficeWDDB";
import CardMyOfficeWDYB from "@/components/CardMyOffice/CardMyOfficeWDYB";
import CardMyOfficeWDFQ from "@/components/CardMyOffice/CardMyOfficeWDFQ";
// import CardMyOfficeSWCX from "@/components/CardMyOffice/CardMyOfficeSWCX";

export default {
  name: "CardMyOffice",
  components: {
    CardMyOfficeWDDB,
    CardMyOfficeWDYB,
    CardMyOfficeWDFQ
    // CardMyOfficeSWCX
  },
  props: {},
  data() {
    return {
      active: "CardMyOfficeWDDB"
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.active {
  position: relative;
  color: #4b5fb1;
}

.active::after {
  display: block;
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #4b5fb1;
}
</style>
